import { commonHeaderAd } from '../header-ad';

export const commonFooterAd = {
  ...commonHeaderAd
};
